import React from 'react';
import { Status } from '../../types';
import { useTheme } from '../../contexts/ThemeContext';

const lightStatusStyles: Record<Status, string> = {
  new: 'bg-green-100 text-green-800',
  processing: 'bg-yellow-100 text-yellow-800',
  resolved: 'bg-blue-100 text-blue-800',
  closed: 'bg-gray-100 text-gray-800',
};

const darkStatusStyles: Record<Status, string> = {
  new: 'bg-green-900/30 text-green-400',
  processing: 'bg-yellow-900/30 text-yellow-400',
  resolved: 'bg-blue-900/30 text-blue-400',
  closed: 'bg-gray-900/30 text-gray-400',
};

interface TicketStatusBadgeProps {
  status: Status;
}

export default function TicketStatusBadge({ status }: TicketStatusBadgeProps) {
  const { theme } = useTheme();

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
      theme === 'dark' ? darkStatusStyles[status] : lightStatusStyles[status]
    }`}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}